<template>
  <div class="w-100pct">
    <div class="item-list f-left w-100pct pd-vtc-10px al-center" v-for="(item, index) in items" :key="index">
      <div class="w-15pct f-left">
        <img :src="item.image" alt="" width="100%">
      </div>
      <div class="w-85pct f-left t-al-left pd-l-10px">
        <div>
          <span class="f-s-16px f-w-bold">{{ item.name }} ({{ item.code }}) </span>
        </div>
        <div>
          <span class="">{{ item.option }}</span>
        </div>
        <div class="dp-flex jtf-ct-space-between">
          <div class="w-80pct">
            ฿ {{ item.price | showFullPriceFormat() }}
          </div>
          <div class="w-20pct">
            <svg-filler class="cs-pointer"  @click="confirmCustomDelete(item)" path="/static/svg/trash-alt-regular.svg" :fill="'#1b0000'" width="20px" height="20px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  name: 'list-cart',
  methods: {
    ...mapActions([
      'addQuantity',
      'removeItem'
    ]),
    confirmCustomDelete (item) {
      console.log(item)
      this.$dialog.confirm({
        title: 'ลบสินค้าออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าชิ้นนี้</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: () => {
          this.removeItem(item)
          this.$emit('clearPromotionCode')
        }
      })
    }
  }
}
</script>
<style scoped>
.item-list {
  border-bottom: 1px solid;
  border-color: #cfcfcf;
}

.remove-icon {
  color: #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/views/cart/ListCart.vue